import client from 'services/apollo-client';
import {
  useQuery,
  QueryHookOptions,
  makeVar,
  QueryResult,
} from '@apollo/client';
import usePrepareSurfaceNodes from 'components/canvas/hooks/use-prepare-surface-nodes';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';
import { isNull } from 'lodash';
import { SurfaceNodePointsTo, SurfaceNodeUnion } from 'graphql/types';
import React from 'react';
import { useCanvasLoadingOperations } from 'components/canvas/hooks/use-canvas-loading';

const isPollingSurfaceNodes = makeVar<boolean>(true);

function setSurfaceNodePolling(isPolling: boolean): void {
  isPollingSurfaceNodes(isPolling);
}

export function useFetchSurfaceNodesOperations() {
  return { isPollingSurfaceNodes, setSurfaceNodePolling };
}

interface Response {
  error: string;
  nodes: SurfaceNodeUnion[];
}

export default function useFetchSurfaceNodes(
  surface: string,
  options?: QueryHookOptions<any, any>,
): QueryResult<Response> & {
  nodes: SurfaceNodeUnion[];
  nodeEdges: SurfaceNodePointsTo[];
} {
  const { setIsLoading } = useCanvasLoadingOperations();

  const params = useQuery(surfaceNodesQuery, {
    variables: { input: { filter: { surface } } },
    client,
    ...options,
    errorPolicy: 'none',
    skip: isNull(surface),
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-only',
  });

  React.useEffect(() => {
    setIsLoading(params.loading);
  }, [params.loading]);

  const { nodes, nodeEdges } = usePrepareSurfaceNodes(
    params.data?.surfaceNodes?.nodes,
    surface,
  );

  return { ...params, nodes, nodeEdges };
}
